//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'weekSelect',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit("change", this.weekFormatFun(this.weekYear));
  },
  methods: {
    // 周变化
    onweekChange: function onweekChange(date, dateString) {
      this.weekYear = date;
      this.$emit('change', this.weekFormatFun(this.weekYear));
    }
  }
};